module.exports = __webpack_public_path__ + "assets/img/2.e77f92fe.jpg";